import Logger from '@medflex/utils/Logger';

export const FLUTTER_CALLBACKS = {
  UPDATE_PROFILE_IMAGE: 'update_profile_image',
};

export const callFlutterHandler = handlerName => {
  try {
    return window.top.flutter_inappwebview.callHandler(handlerName);
  } catch (e) {
    Logger.error('[WebView Error] - flutter callback could not be called.', e);
    throw e;
  }
};
